<div class="card-header text-center bg-primary text-white">
    <h5 class="mb-0"><strong>{{ titleTax }}</strong></h5>
</div>

<div class="card-body">
    <ul class="list-group list-group-flush">
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.programId'
                |
                translate
                }}</span>
            <strong> {{ idTaxGeneric }} </strong>
        </li>

        <span class="mt-3">
            <strong> {{'tuition-calc.descriptionTax' | translate }}
            </strong>
        </span>

        @for (tr of listTraductionGeneric; track
        $index) {
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span class="text-muted">{{ tr.isoLanguageCode == 'es' ?
                'Español' :
                tr.isoLanguageCode == 'ca' ? 'Catalán' : 'Inglés'
                }}</span>
            <span>{{ tr.description }}</span>
        </li>
        }
    </ul>
    <span class="mt-2">
        <strong>{{'tuition-calc.tuitionAcademic' | translate }}</strong>
    </span>

    <ul class="list-group list-group-flush">
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.numberTimesBeenApplied'
                |
                translate
                }}</span>
            <strong> {{
                taxAndDiscount.numberTimesBeenApplied }}
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.priceBase'
                |
                translate
                }}</span>
            <strong> {{ taxAndDiscount.priceBase }} €
            </strong>
        </li>

        <!-- General -->
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.priceExclVat'
                |
                translate
                }}</span>
            <strong> {{ taxAndDiscount.feeAmountExclVat }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.grossPrice'
                |
                translate
                }}</span>
            <strong> {{
                taxAndDiscount.feeGrossPrice }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.vatAmount'
                |
                translate
                }} </span>
            <strong> {{ taxAndDiscount.vatAmount }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.priceInclVat'
                |
                translate
                }} </span>
            <strong> {{ taxAndDiscount.feeAmountInclVat }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.ivaApplied'
                |
                translate
                }} </span>
            <strong> {{ taxAndDiscount.vatPercentage }} %
            </strong>
        </li>

        <span class="mt-3">
            <strong>{{'tuition-calc.traductionVat' | translate }}</strong>
        </span>

        @for (trVat of
        taxAndDiscount.listVatRateDescription; track $index)
        {
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span class="text-muted">{{ trVat.isoLanguageCode == 'es' ?
                'Español' :
                trVat.isoLanguageCode == 'ca' ? 'Catalán' : 'Inglés'
                }}</span>
            <span>{{ trVat.description }}</span>
        </li>
        }

        <!-- Student -->
        <span class="mt-3">
            <strong>{{'tuition-calc.appliedStudent' | translate }}</strong>
        </span>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.grossPriceStudent'
                |
                translate
                }}</span>
            <strong> {{
                taxAndDiscount.feeGrossPriceStudent }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.priceExclVat'
                |
                translate
                }}</span>
            <strong> {{
                taxAndDiscount.feeAmountExclVatStudent }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.vatAmount'
                |
                translate
                }} </span>
            <strong> {{ taxAndDiscount.vatAmountStudent }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.priceInclVat'
                |
                translate
                }} </span>
            <strong> {{
                taxAndDiscount.feeAmountInclVatStudent }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.ivaApplied'
                |
                translate
                }} </span>
            <strong> {{ taxAndDiscount.vatPercentageStudent
                }} %
            </strong>
        </li>

        @if(taxAndDiscount.listVatTypeDescriptionStudent.length
        > 1) {
        <span class="mt-3">
            <strong>{{'tuition-calc.traductionVat' | translate }}</strong>
        </span>

        @for (trVatStudent of
        taxAndDiscount.listVatTypeDescriptionStudent ; track
        $index)
        {
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span class="text-muted">{{ trVatStudent.isoLanguageCode == 'es'
                ?
                'Español' :
                trVatStudent.isoLanguageCode == 'ca' ? 'Catalán' : 'Inglés'
                }}</span>
            <span>{{ trVatStudent.description }}</span>
        </li>
        }
        }

        <!-- Company -->
        <span class="mt-3">
            <strong>{{'tuition-calc.appliedCompany' | translate }}</strong>
        </span>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.grossPriceCompany'
                |
                translate
                }}</span>
            <strong> {{
                taxAndDiscount.feeGrossPriceCompany }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.priceExclVat'
                |
                translate
                }}</span>
            <strong> {{
                taxAndDiscount.feeAmountExclVatCompany }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.vatAmount'
                |
                translate
                }} </span>
            <strong> {{ taxAndDiscount.vatAmountCompany }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.priceInclVat'
                |
                translate
                }} </span>
            <strong> {{
                taxAndDiscount.feeAmountInclVatCompany }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.ivaApplied'
                |
                translate
                }} </span>
            <strong> {{ taxAndDiscount.vatPercentageCompany
                }} %
            </strong>
        </li>

        @if(taxAndDiscount.listVatTypeDescriptionCompany.length
        > 1) {
        <span class="mt-3">
            <strong>{{'tuition-calc.traductionVat' | translate }}</strong>
        </span>

        @for (trVatCompany of
        taxAndDiscount.listVatTypeDescriptionCompany ; track
        $index)
        {
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span class="text-muted">{{ trVatCompany.isoLanguageCode == 'es'
                ?
                'Español' :
                trVatCompany.isoLanguageCode == 'ca' ? 'Catalán' : 'Inglés'
                }}</span>
            <span>{{ trVatCompany.description }}</span>
        </li>
        }
        }

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.discountApplied'
                |
                translate
                }} </span>
            <strong> {{
                taxAndDiscount.totalDiscountsAmountApplied
                }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.discountAppliedStudent'
                |
                translate
                }} </span>
            <strong> {{
                taxAndDiscount.totalDiscountsAmountAppliedStudent
                }} €
            </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{
                'tuition-calc.discountAppliedCompany'
                |
                translate
                }} </span>
            <strong> {{
                taxAndDiscount.totalDiscountsAmountAppliedCompany
                }} €
            </strong>
        </li>

        @if(this.listMandatoryAdministrativeFeeApplied) {
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>Tasa de modificación: </span>
            <strong>{{administrativeModificationFeeIndicator}} </strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>Tasa de cancelación: </span>
            <strong>{{administrativeCancelationFeeIndicator}} </strong>
        </li>
        }

        @if(taxAndDiscount.listDiscountsApplied.length >= 1) {
        <span class="mt-3 d-flex justify-content-between">
            <strong>{{'tuition-calc.descompte' | translate
                }}</strong>
        </span>
        <li class="list-group-item py-2 d-flex justify-content-between">
            @for (discApplied of discounts; track discApplied.idDiscountCode) {
            <button type="button" class="badge btn btn-primary fs-6" (click)="viewDiscount(discApplied)">
                {{'tuition-calc.nameDisocunt' | translate}}: #{{discApplied.idDiscountCode }}</button>
            }
        </li>
        }
    </ul>
</div>

@if(this.isViewDiscount) {
<app-discount-modal [disc]="this.discountViewModal"></app-discount-modal>
}